import React from 'react';
import PropTypes from 'prop-types';

import '../CallForSpeakers.scss';

export const SubmitFailedMessage = ({ formFailed, closeAlert }) =>
  formFailed ? (
    <div className="notification is-danger alert-submit-failed text-center" role="alert">
      <button
        aria-label="Close"
        className="delete"
        data-dismiss="alert"
        onClick={closeAlert}
        type="button">
        <span aria-hidden="true">×</span>
      </button>
      Something went wrong and your information was not stored. Please, try again.
    </div>
  ) : null;

export const InProgress = ({ formSubmitInProgress }) =>
  formSubmitInProgress ? <i className="fa fa-spinner fa-spin fa-3x fa-fw" /> : null;

export const MissingFieldsMessage = ({ isValidForm }) =>
  isValidForm() ? null : (
    <p className="text-center cfs-bottom-request">
      <b className="text-danger cfs-request">* - fields are required</b>
    </p>
  );

export const UnsavedPhotoMessage = ({ isDirty }) =>
  isDirty ? (
    <p className="text-center cfs-bottom-request">
      <b className="text-danger cfs-request">There is missing or unsaved photo</b>
    </p>
  ) : null;

SubmitFailedMessage.propTypes = {
  closeAlert: PropTypes.func.isRequired,
  formFailed: PropTypes.bool.isRequired
};

InProgress.propTypes = {
  formSubmitInProgress: PropTypes.bool.isRequired
};

MissingFieldsMessage.propTypes = {
  isValidForm: PropTypes.func.isRequired
};

UnsavedPhotoMessage.propTypes = {
  isDirty: PropTypes.bool.isRequired
};
